var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptionsIcon = function SvgOptionsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.85 4.6998H9.3C8.96863 4.6998 8.7 4.96843 8.7 5.2998V8.5998H6.3V1.3998C6.3 1.06843 6.03137 0.799805 5.7 0.799805H3.3C2.96863 0.799805 2.7 1.06843 2.7 1.3998V4.6998H0.15C0.0671573 4.6998 0 4.76696 0 4.8498V5.1498C0 5.23265 0.0671573 5.2998 0.15 5.2998H2.7C3.03137 5.2998 3.3 5.03118 3.3 4.6998V1.3998H5.7V8.5998C5.7 8.93118 5.96863 9.1998 6.3 9.1998H8.7C9.03137 9.1998 9.3 8.93118 9.3 8.5998V5.2998H11.85C11.9328 5.2998 12 5.23265 12 5.1498V4.8498C12 4.76696 11.9328 4.6998 11.85 4.6998Z",
    fill: "currentColor"
  })));
};
export { SvgOptionsIcon as ReactComponent };